<template>
    <div>
        <div class="tixstock-search-skeleton">
            <div class="tixstock-search-box-skeleton">
                <div class="search-icon-skeleton"></div>
                <div class="search-input-skeleton"></div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonSearchbar'
}
</script>
<style scoped>
.tixstock-search-skeleton {
  position: relative;
  width: 100%;
  max-width: 600px;
  background: white;
}

.tixstock-search-box-skeleton {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 20px;
}


.search-icon-skeleton {
  width: 20px;
  height: 20px;
  background: #e0e0e0;
  border-radius: 50%;
  margin-right: 12px;
  flex-shrink: 0;
  animation: pulse 1.5s infinite;
}

.search-input-skeleton {
  flex: 1;
  height: 16px;
  background: #e0e0e0;
  border-radius: 4px;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    background-color: #f0f0f0;
  }
  50% {
    background-color: #e0e0e0;
  }
  100% {
    background-color: #f0f0f0;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .tixstock-search-skeleton {
    max-width: 100%;
  }
}

</style>